/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export const getFiles = (feature: BaseFeature): string[] => {
    return [
        'index.html',
        '404.html',
        'web.py',
    ];
};

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    let blocks: Array<CodeBlock> = [];

    if (feature.getSettingValue('ENABLED').toString() === '0') {
        return blocks;
    }

    blocks.push({
        location: 'IMPORTS',
        blockType: BlockType.CODE,
        template: `
import web
from web import unquote`,
    });

    blocks.push({
        location: 'FUNCTION_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
async def http_send_file(writer, file_name):
    size = os.stat(file_name)[6]
    contentType = 'text/plain'
    if file_name.endswith('.js.gz'):
        contentType = 'text/javascript'
    elif file_name.endswith('.html'):
        contentType = 'text/html'
    elif file_name.endswith('.json'):
        contentType = 'application/json'
    # write http headers
    writer.write(b'HTTP/1.0 200 OK\\r\\n')
    writer.write(f'Content-Type: {contentType}\\r\\n')
    if file_name.endswith('.gz'):
        writer.write(b'Content-encoding: gzip\\r\\n')
    writer.write(f'Content-length: {str(size)}\\r\\n')
    writer.write(b'\\r\\n')
    # write page body
    f=open(file_name, 'rb')
    index=0
    while index < size:
        chunk = f.read(1024)
        writer.write(chunk)
        index += len(chunk)
        await writer.drain()
        
@webserver.route('/')
async def handler(r, w):
    # write http headers
    w.write(b'HTTP/1.0 200 OK\\r\\n')
    w.write(b'Content-Type: text/html; charset=utf-8\\r\\n')
    w.write(b'\\r\\n')
    # write page body
    f=open('index.html')
    w.write(f.read())
    # drain stream buffer
    await w.drain()`,
    });

    blocks.push({
        location: 'VARIABLE_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
webserver = web.App(host='0.0.0.0', port=80)`,
    });


    blocks.push({
        location: 'ASYNC_TASKS',
        blockType: BlockType.CODE,
        template: 'loop.create_task(webserver.serve())',
    });

    const ENDPOINTS = feature.getSettingValue('ENDPOINTS');
    for (let i = 0; i < ENDPOINTS.length; i++) {
        blocks = blocks.concat(ENDPOINTS[i].getCodeBlocks());
    }

    return blocks;
};
